import { onDocumentReady } from "@story/story_assets";

let threshold = 15;
let lastScrollPosition = null;

function onScroll() {
	if (lastScrollPosition === null) {
		lastScrollPosition = window.scrollY;
	}

	let isScrollingDown = lastScrollPosition <= window.scrollY;

	document.body.classList.toggle("scrolling-down", isScrollingDown);
	document.body.classList.toggle("scrolling-up", !isScrollingDown);

	let isOnTop = window.scrollY < threshold;
	document.body.classList.toggle("scrolling", !isOnTop);

	lastScrollPosition = window.scrollY;
}

window.addEventListener("scroll", onScroll, { passive: true });


onDocumentReady(() => {
	onScroll();
})
